import React, { useState } from "react"
import "./ContactUs.css"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

const ContactUs = () => {
  const success = () => {
    toast.success("Your response is recorded , we will contact u soon.", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    })
  }
  const warn = (msg) => {
    toast.warn(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    })
  }
  const error_msg = () => {
    toast.error("Error while submitting the form.", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    })
  }

  const handleSubmit = (e) => {
    // console.log({ name });
    // console.log({ lastName });
    // console.log({ email });
    // console.log({ phone });
    // console.log({ msg });
    if (name.length < 3) {
      warn("Enter a valid name")
      return
    }
    if (lastName.length !== 0 && lastName.length < 3) {
      warn("Enter a valid lastName")
      return
    }
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}$/i.test(email)) {
      warn("Enter a valid email")
      return
    }
    if (phone.length !== 10) {
      warn("Enter a valid phone number")
      return
    }
    if (msg.length < 10) {
      warn("Enter a valid message")
      return
    }
    if (loading) {
      warn("already processing !")
      return
    }

    const formData = {
      name,
      email,
      message: msg,
      lastName,
      phoneNumber: phone,
    }
    // console.log({ formData });
    setLoading(true)
    setName("")
    setEmail("")
    setLastName("")
    setMsg("")
    setPhone("")
    fetch("https://fabform.io/f/4tFhyRF", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data)
        setLoading(false)
        success()
      })
      .catch((error) => {
        console.error("Error:", error)
        setLoading(false)
        error_msg()
      })
  }
  const [loading, setLoading] = useState(false)
  const [name, setName] = useState("")
  const [lastName, setLastName] = useState("")
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [msg, setMsg] = useState("")
  return (
    <>
      <ToastContainer />
      <div className="contact border-t-2" id="contactUs">
        <div className="contact-container">
          <div className="contact-left">
            <div className="left-up">
              <input
                type="text"
                placeholder="First name*"
                className="form"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <input
                type="text"
                placeholder="Last name"
                className="form"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
              <input
                type="number"
                placeholder="Mobile Number"
                className="form"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                maxLength={10}
              />
              <input
                type="email"
                placeholder="Email"
                className="form"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <textarea
                placeholder="Message"
                className="message form"
                value={msg}
                onChange={(e) => setMsg(e.target.value)}
              ></textarea>
            </div>

            <div className="left-down">
              <div className="button-grp">
                <button
                  className="text-white-default group md:mt-20 uppercase border h-12 pl-6 text-left items-center justify-center bg-blue-light flex hover:shadow-md hover:shadow-blue-dark overflow-hidden relative"
                  onClick={handleSubmit}
                >
                  <span className="w-52">Send Us Message</span>
                  <span className="bg-yellow-default h-full flex items-center justify-center w-14 absolute skew-x-12 -right-2 border-l-2">
                    <svg
                      className="w-6 h-6 group-hover:-translate-x-4 duration-700"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3"
                      />
                    </svg>
                  </span>
                </button>
              </div>
            </div>
          </div>

          <div className="contact-right">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <hr className="w-10  border-2 rounded-full border-yellow-default" />
              <p className="small-heading" style={{ marginLeft: "0.2rem" }}>
                Contact Us.
              </p>
            </div>
            <h2>
              Feel Free To Contact <br /> With Us
            </h2>
            <p className="para">
              Get in touch with us anytime and we’ll happily answer your
              questions and help any way we can.
            </p>

            <div
              className="right-down hover:cursor-pointer"
              onClick={() => {
                window.open("tel:+1-780-399-7475")
              }}
            >
              <div className="icon-grp">
                <div className="icons">
                  <svg
                    viewBox="-2.4 -2.4 28.80 28.80"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    //   xmlns:xlink="http://www.w3.org/1999/xlink"
                    fill="#000000"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0">
                      <rect
                        x="-2.4"
                        y="-2.4"
                        width="28.80"
                        height="28.80"
                        rx="2.88"
                        fill="#e8bb36"
                        strokewidth="0"
                      ></rect>
                    </g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      {" "}
                      <title>phone_call_fill</title>{" "}
                      <g
                        id="页面-1"
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        {" "}
                        <g
                          id="Contact"
                          transform="translate(-576.000000, -48.000000)"
                          fill-rule="nonzero"
                        >
                          {" "}
                          <g
                            id="phone_call_fill"
                            transform="translate(576.000000, 48.000000)"
                          >
                            {" "}
                            <path
                              d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z"
                              id="MingCute"
                              fill-rule="nonzero"
                            >
                              {" "}
                            </path>{" "}
                            <path
                              d="M6.85728,2.44489 C7.99928,3.27790429 8.88915755,4.41552061 9.65001761,5.50316536 L10.0920364,6.14691904 L10.0920364,6.14691904 L10.509,6.76166 L10.509,6.76166 C10.9374,7.38835 10.8351,8.244 10.2531,8.74772 L8.30198,10.1967 C8.10859,10.3404 8.04429,10.6014 8.16028,10.8125 C8.60173,11.6161 9.38819,12.8119 10.2882,13.7119 C11.1891,14.6128 12.4414,15.45 13.3002,15.9412 C13.5229,16.0685 13.803,15.9948 13.9438,15.7803 L15.2131,13.8468 C15.6999,13.1991 16.6088,13.0576 17.2695,13.5149 L17.9332982,13.9735916 C19.1717645,14.8335207 20.5037538,15.8105615 21.521,17.1133 C21.8626,17.5507 21.9133,18.1227 21.7096,18.5981 C20.8728,20.5507 18.7552,22.2136 16.5524,22.1325 L16.2518759,22.1158001 L16.2518759,22.1158001 L16.0189256,22.0957065 L16.0189256,22.0957065 L15.7611336,22.0668244 L15.7611336,22.0668244 L15.4795621,22.0277651 L15.4795621,22.0277651 L15.1752731,21.97714 C15.1227241,21.9676615 15.0692729,21.9576432 15.0149414,21.9470562 L14.6785676,21.8764784 C14.6208039,21.8635009 14.5622043,21.8498968 14.5027909,21.8356372 L14.136722,21.7419821 L14.136722,21.7419821 L13.7521839,21.6312063 L13.7521839,21.6312063 L13.3502388,21.501921 C11.5039131,20.8764078 9.16110938,19.6464875 6.75735,17.2427 C4.35356813,14.8389125 3.12365344,12.4961028 2.49813876,10.6497861 L2.36885301,10.2478433 L2.36885301,10.2478433 L2.25807648,9.86330795 L2.25807648,9.86330795 L2.16442042,9.4972422 L2.16442042,9.4972422 L2.08649611,9.15070812 C2.06298899,9.03857004 2.04187237,8.92986425 2.02291481,8.82476776 L1.97228778,8.52048321 L1.97228778,8.52048321 L1.93322631,8.23891652 L1.93322631,8.23891652 L1.90434165,7.98112978 L1.90434165,7.98112978 L1.88424507,7.74818505 L1.88424507,7.74818505 L1.86754,7.44767 L1.86754,7.44767 C1.78675,5.25221 3.46855,3.11902 5.41215,2.28605 C5.86822,2.09059 6.4206,2.12636 6.85728,2.44489 Z M14.9917005,6.03952315 L15.1077,6.05315 C15.8356,6.18149 16.5042,6.53699 17.0177,7.06867 C17.5311,7.60035 17.863,8.28093 17.9659,9.01287 C18.0428,9.55978 17.6617,10.0654 17.1148,10.1423 C16.6069643,10.2137071 16.1346531,9.89022337 16.0082806,9.40576032 L15.9854,9.29121 C15.9413,8.97753 15.799,8.68585 15.579,8.45799 C15.3955833,8.26809833 15.1660556,8.13065111 14.9140856,8.05827565 L14.7604,8.02276 C14.2166,7.92686 13.8534,7.4082 13.9493,6.86431 C14.03835,6.35926 14.4919571,6.01004352 14.9917005,6.03952315 L14.9917005,6.03952315 Z M15,2.99999 C15.7879,2.99999 16.5682,3.15518 17.2961,3.45671 C18.0241,3.75824 18.6855,4.2002 19.2427,4.75735 C19.7998,5.3145 20.2418,5.97594 20.5433,6.70389 C20.8448,7.43184 21,8.21206 21,8.99999 C21,9.55227 20.5523,9.99999 20,9.99999 C19.48715,9.99999 19.0644908,9.61394571 19.0067275,9.11661025 L19,8.99999 C19,8.4747 18.8966,7.95456 18.6955,7.46926 C18.4945,6.98395 18.1999,6.543 17.8284,6.17156 C17.457,5.80013 17.0161,5.50549 16.5307,5.30447 C16.1262833,5.13695333 15.6977,5.03718667 15.2620796,5.00858435 L15,4.99999 C14.4477,4.99999 14,4.55227 14,3.99999 C14,3.44771 14.4477,2.99999 15,2.99999 Z"
                              id="形状"
                              fill="#ffffff"
                            >
                              {" "}
                            </path>{" "}
                          </g>{" "}
                        </g>{" "}
                      </g>{" "}
                    </g>
                  </svg>
                </div>
                <h4>Phone</h4>
                <p>+1-780-399-7475</p>
              </div>

              <div
                className="icon-grp hover:cursor-pointer"
                onClick={() => {
                  window.open("mailto:millwoodsfur@gmail.com")
                }}
              >
                <div className="icons">
                  <svg
                    fill="#ffffff"
                    viewBox="-2.4 -2.4 28.80 28.80"
                    xmlns="http://www.w3.org/2000/svg"
                    stroke="#ffffff"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0">
                      <rect
                        x="-2.4"
                        y="-2.4"
                        width="28.80"
                        height="28.80"
                        rx="3.4560000000000004"
                        fill="#e8bb36"
                        strokewidth="0"
                      ></rect>
                    </g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <path d="M22,5V9L12,13,2,9V5A1,1,0,0,1,3,4H21A1,1,0,0,1,22,5ZM2,11.154V19a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V11.154l-10,4Z"></path>
                    </g>
                  </svg>
                </div>
                <h4>Mail</h4>
                <p>millwoodsfur@gmail.com</p>
              </div>

              <div
                className="icon-grp hover:cursor-pointer"
                onClick={() => {
                  window.open("https://maps.app.goo.gl/Cp5RAaKs241SJ8deA")
                }}
              >
                <div className="icons">
                  <svg
                    fill="#ffffff"
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    //   xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="-59.36 -59.36 514.43 514.43"
                    //   xml:space="preserve"
                    stroke="#ffffff"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0">
                      <rect
                        x="-59.36"
                        y="-59.36"
                        width="514.43"
                        height="514.43"
                        rx="36.010099999999994"
                        fill="#e8bb36"
                        strokewidth="0"
                      ></rect>
                    </g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      {" "}
                      <g>
                        {" "}
                        <path d="M197.849,0C122.131,0,60.531,61.609,60.531,137.329c0,72.887,124.591,243.177,129.896,250.388l4.951,6.738 c0.579,0.792,1.501,1.255,2.471,1.255c0.985,0,1.901-0.463,2.486-1.255l4.948-6.738c5.308-7.211,129.896-177.501,129.896-250.388 C335.179,61.609,273.569,0,197.849,0z M197.849,88.138c27.13,0,49.191,22.062,49.191,49.191c0,27.115-22.062,49.191-49.191,49.191 c-27.114,0-49.191-22.076-49.191-49.191C148.658,110.2,170.734,88.138,197.849,88.138z"></path>{" "}
                      </g>{" "}
                    </g>
                  </svg>
                </div>
                {/* <h4>Location</h4> */}
                <p>3307 9 Street Northwest Edmonton, AB T6T 1A4 Canada</p>
              </div>

              <div className="icon-grp">
                <div className="icons">
                  <svg
                    fill="#ffffff"
                    viewBox="-3.2 -3.2 38.40 38.40"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    stroke="#ffffff"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0">
                      <rect
                        x="-3.2"
                        y="-3.2"
                        width="38.40"
                        height="38.40"
                        rx="3.072"
                        fill="#e8bb36"
                        strokewidth="0"
                      ></rect>
                    </g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      {" "}
                      <title>open</title>{" "}
                      <path d="M28 31h-24c-1.657 0-3-1.344-3-3v-14c0-1.657 1.343-3 3-3h24c1.656 0 3 1.343 3 3v14c0 1.656-1.344 3-3 3zM8 18.041c-1.657 0-3 1.567-3 3.5 0 1.934 1.343 3.5 3 3.5s3-1.566 3-3.5c0-1.933-1.344-3.5-3-3.5zM15.78 18.898c-0.115-0.237-0.269-0.422-0.458-0.553-0.19-0.132-0.426-0.221-0.707-0.268-0.2-0.037-0.49-0.055-0.87-0.055h-1.783v6.914h1.008v-2.016h0.842c0.81 0 1.368-0.356 1.679-0.693 0.309-0.338 0.464-1.812 0.464-2.299-0.001-0.282-0.059-0.793-0.175-1.030zM21.024 23.945h-3.058v-2.008h2.956v-0.93h-2.956v-2.055h3.050v-0.93h-3.995v6.914h4.003v-0.991zM26.954 18.023h-0.914v5.31l-3.012-5.31h-1.027v6.914h0.977v-5.061l3.012 5.061h0.965v-6.914zM13.823 21.93h-0.853v-2.977h0.838c0.343 0 0.578 0.017 0.706 0.051 0.197 0.055 0.357 0.166 0.478 0.336s0.182 0.375 0.182 0.613c0 0.33-0.103 1.522-0.309 1.704s-0.553 0.273-1.042 0.273zM8 24.125c-1.104 0-2-1.119-2-2.5s0.896-2.5 2-2.5 2 1.119 2 2.5-0.896 2.5-2 2.5zM25 11l-7.322-5.45c-0.344 0.277-0.775 0.45-1.25 0.45-0.662 0-1.244-0.325-1.607-0.821l-7.821 5.821h-1l8.493-6.518c-0.038-0.155-0.065-0.315-0.065-0.482 0-1.104 0.896-2 2-2 1.105 0 2 0.896 2 2 0 0.359-0.103 0.692-0.269 0.984l7.841 6.016h-1z"></path>{" "}
                    </g>
                  </svg>
                </div>
                <h4>Open</h4>
                <p>9:00 A.M to 07:00 P.M</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <iframe
        className="w-[90%] h-[500px] mx-auto mb-6 -mt-10"
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d9499.888559766203!2d-113.352531!3d53.468958!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x53a01995cf6af62f%3A0x11218297de14f543!2sMillwoods%20Furnace%20Cleaning%20Ltd!5e0!3m2!1sen!2sin!4v1710141554748!5m2!1sen!2sin"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </>
  )
}

export default ContactUs
